import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';
// import { environment } from '../../../../environments/environment';

import { API } from 'aws-amplify';
import { Observable, of } from 'rxjs';
import { ConfigService } from '../../config';
import { VoucherDemoModeService } from '../../vouchers/demo/voucher-demo-mode.service';
import { buildDemoMachines } from '../../vouchers/demo/voucher-demo-dashboard';

/**
 * Campus interface matching API response structure
 */
export interface Campus {
	campus_id: string | number;
	name: string;
	[key: string]: any; // Allow additional properties from API
}

/**
 * Notification subscription data interface
 */
export interface NotificationSubscription {
	analyticsSubscribed: boolean;
	stockoutSubscribed: boolean;
	stockoutAlertThreshold: number | null;
	campusIds: (string | number)[];
	distiIds?: (string | number)[]; // Optional: distributor IDs for superadmin analytics subscriptions
}

@Injectable({
  providedIn: 'root'
})
export class UserSettingsHttpService {

    apiName: string;

    constructor(
		private http: HttpClient,
		private configService: ConfigService,
		private demoMode: VoucherDemoModeService
	) {
        this.apiName = this.configService.get('host');
    }

	postSubscription(formObj) {
		return new Observable((observer: any) => {
			const path = '/dashboard/subscription';
			const params = {
				body: formObj
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	updateSummaryReport(action) {
		return new Observable((observer: any) => {
			const path = '/dashboard/summary-report/' + action;
			const params = {
				body: {}
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getExistingSubsDet() {
		return new Observable((observer: any) => {
			const path = '/dashboard/get-existing-subs';
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getRegTerr(regionId, territoryId): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/' + regionId + '/' + territoryId;
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getTopics() {
		return new Observable((observer: any) => {
			const path = '/dashboard/get-topics';
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getDistis() {
		return new Observable((observer: any) => {
			const path = '/dashboard/get-distis';
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}



	getUserAttr() {
		return new Observable((observer: any) => {
			const path = '/dashboard/get-user-attr';
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getClients(queryParams) {
		return new Observable((observer: any) => {
			const path = '/dashboard/get-clients';
			const myInit = {
				response: false,
				queryStringParameters: queryParams
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getCampus(queryParams: any): Observable<Campus[]> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get-campus';
			const myInit = {
				response: false,
				queryStringParameters: queryParams
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getMarkets(queryParams) {
		return new Observable((observer: any) => {
			const path = '/dashboard/get-markets';
			const myInit = {
				response: false,
				queryStringParameters: queryParams
			};
			API.get(this.apiName, path, myInit).then(response => {
				observer.next(response.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getRecipes(queryParams?: any) {
		return new Observable((observer: any) => {
			const path = '/dashboard/get-recipes';
			const myInit: any = {
				response: false
			};
			if (queryParams) {
				myInit.queryStringParameters = queryParams;
			}
			API.get(this.apiName, path, myInit).then(response => {
				observer.next(response.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getProducts(queryParams?: any): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get-products';
			const myInit: any = {
				response: false
			};
			if (queryParams) {
				myInit.queryStringParameters = queryParams;
			}
			API.get(this.apiName, path, myInit).then(response => {
				observer.next(response.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getMachines(queryParams: any): Observable<any> {
		if (this.demoMode.isEnabled()) {
			return of(buildDemoMachines());
		}
		return new Observable((observer: any) => {
			const path = '/dashboard/get_all_macs';
			const myInit = {
				response: false,
				queryStringParameters: queryParams
			};
			API.get(this.apiName, path, myInit).then(response => {
				observer.next(response.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getNotifications(userId: string): Observable<NotificationSubscription | null> {
		return new Observable((observer: any) => {
			const path = '/dashboard/analytics/get-notifications';
			const myInit = {
				response: false,
				queryStringParameters: {
					user_id: userId
				}
			};
			API.get(this.apiName, path, myInit).then(response => {
				observer.next(response.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	updateNotifications(payload: any): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/analytics/update-notifications';
			const params = {
				body: payload
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}
}
